import React, { Component, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  DetailsList,
  DetailsListLayoutMode,
  DetailsRow,
  Dropdown,
  Fabric,
  IColumn,
  IDetailsFooterProps,
  IDetailsListProps,
  IDetailsRowStyles,
  Label,
  ScrollablePane,
  ScrollbarVisibility,
  ShimmeredDetailsList,
  Sticky,
  StickyPositionType,
  TextField,
  Text,
  SelectionMode,
} from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import { PSListPaneFilter } from '../../../types/progressStatement';
import {
  InstructionRegisterListPaneFilter,
  InstructionRegisterListItem,
} from '../../../types/instructionRegister';
import { formatDate, getProject } from '../../../shared/util';
import CustomDatePicker from '../../../shared/customDatePicker/customDatePicker';

export const classNames = mergeStyleSets({
  wrapper: {
    height: 'calc(100vh - 25vh)!important',
    position: 'relative',
  },
  filter: {
    paddingBottom: 20,
    maxWidth: 100,
  },
  header: {
    margin: 0,
  },
  row: {
    display: 'inline-block',
  },
});

const ListPaneComponent = (props: {
  filter: InstructionRegisterListPaneFilter;
  selection: any;
  columns: IColumn[];
  listPaneItems: InstructionRegisterListItem[];
  handleListPaneItemClick: (id: string) => void;
  handleFilterChange: (filter: InstructionRegisterListPaneFilter) => void;
  isDataLoaded?: boolean;
  loadMsg: string;
  resetSelection: () => void;
  dropDownOptions: any;
}) => {
  const { t } = useTranslation();
  const [filter, setFilter] = useState<InstructionRegisterListPaneFilter>(
    props.filter
  );
  const getDropdownWithDefualt = (options: any) => {
    if (options) {
      let defualtOption = [
        {
          key: '0',
          text: t('all'),
          isDefault: true,
        },
      ];
      Array.prototype.push.apply(defualtOption, options);
      return defualtOption;
    } else {
      return [];
    }
  };

  useEffect(() => {
    setFilter(props.filter);
  }, [props.filter]);

  const _onRenderRow: IDetailsListProps['onRenderRow'] = (row) => {
    const customStyles: Partial<IDetailsRowStyles> = {};
    if (row) {
      return (
        <span
          style={{ textDecoration: 'none' }}
          onClick={() => {
            // chnage item id name
            props.handleListPaneItemClick(row.item.id);
          }}
        >
          <DetailsRow {...row} styles={customStyles} />
        </span>
      );
    }
    return null;
  };

  const _onRenderDetailsFooter = (
    detailsFooterProps: IDetailsFooterProps | undefined
  ) => {
    return (
      <DetailsRow
        className="footer-as-filter"
        {...detailsFooterProps}
        columns={detailsFooterProps?.columns}
        item={{}}
        itemIndex={-1}
        groupNestingDepth={detailsFooterProps?.groupNestingDepth}
        selection={detailsFooterProps?.selection}
        onRenderItemColumn={_renderFilterItemColumn}
      // onRenderCheck={_onRenderCheckForFooterRow}
      />
    );
  };

  const _renderFilterItemColumn = (
    item?: InstructionRegisterListItem,
    index?: number,
    column?: IColumn
  ) => {
    switch (column?.key) {
      case 'column1': {
        return (
          <div>
            <TextField
              value={props.filter.title ? props.filter.title : ''}
              onChange={(event, value) => {
                if (value) {
                  props.filter.title = value;
                } else {
                  props.filter.title = null;
                }
                props.handleFilterChange(props.filter);
              }}
            />
          </div>
        );
        break;
      }

      // case 'column2': {
      //   return (
      //     <div>
      //       <TextField
      //         value={props.filter.name ? props.filter.name : ''}
      //         onChange={(event, value) => {
      //           if (value) {
      //             props.filter.name = value;
      //           } else {
      //             props.filter.name = null;
      //           }
      //           props.handleFilterChange(props.filter);
      //         }}
      //       />
      //     </div>
      //   );
      //   break;
      // }

      case 'column3': {
        return (
          <div>
            <Dropdown
              placeholder={t('all')}
              options={[
                { key: '', text: t('all') },
                { key: '100', text: t('technical') },
                { key: '200', text: t('environment') },
                { key: '300', text: t('safety') },
                { key: '400', text: t('health') },
              ]}
              selectedKey={
                props.filter.instructionType
                  ? props.filter.instructionType
                  : '0'
              }
              onChange={(event, value) => {
                if (value) {
                  props.filter.instructionType =
                    value.key != 0 ? value.key.toString() : null;
                } else {
                  props.filter.instructionType = null;
                }
                props.handleFilterChange(props.filter);
              }}
            />
          </div>
        );
        break;
      }

      case 'column4': {
        return (
          <div>
            <Dropdown
              placeholder={t('all')}
              options={getDropdownWithDefualt(
                props.dropDownOptions.pbsInstructionFamily
              )}
              selectedKey={
                props.filter.pbsInstructionFamilyId
                  ? props.filter.pbsInstructionFamilyId
                  : '0'
              }
              onChange={(event, value) => {
                if (value) {
                  props.filter.pbsInstructionFamilyId =
                    value.key != 0 ? value.key.toString() : null;
                } else {
                  props.filter.pbsInstructionFamilyId = null;
                }
                props.handleFilterChange(props.filter);
              }}
            />
          </div>
        );
        break;
      }

      default: {
        break;
      }
    }
  };

  const displayMessage = () => {
    return (
      <div style={{ paddingTop: 36, paddingLeft: 20 }}>
        <Text>{t(props.loadMsg)}</Text>
      </div>
    );
  };
  return (
    <Fabric>
      <div className={`wrapper-holder ${classNames.wrapper}`}>
        <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
          <ShimmeredDetailsList
            items={props.listPaneItems}
            columns={props.columns}
            setKey="set"
            enableShimmer={!props.isDataLoaded}
            layoutMode={DetailsListLayoutMode.justified}
            selectionPreservedOnEmptyClick={true}
            checkboxVisibility={1}
            onRenderRow={_onRenderRow}
            onRenderDetailsFooter={_onRenderDetailsFooter}
            selection={props.selection}
            selectionMode={SelectionMode.single}
            ariaLabelForSelectionColumn="Toggle selection"
            ariaLabelForSelectAllCheckbox="Toggle selection for all items"
            checkButtonAriaLabel="Row checkbox"
            onRenderDetailsHeader={(headerProps, defaultRender) => {
              if (defaultRender !== undefined) {
                return (
                  <Sticky
                    stickyPosition={StickyPositionType.Header}
                    isScrollSynced={true}
                    stickyBackgroundColor="transparent"
                  >
                    <div>{defaultRender(headerProps)}</div>
                  </Sticky>
                );
              } else {
                return <span></span>;
              }
            }}
          />
          {props.isDataLoaded && displayMessage()}
        </ScrollablePane>
      </div>
    </Fabric>
  );
};

const mapStateToProps = (state: any, ownProps: any) => {
  return {
    toleranceStatesFilter: state.projectBreakdown.toleranceStatesFilter,
    productStatesFilter: state.projectBreakdown.productStatesFilter,
    itemTypesFilter: state.projectBreakdown.itemTypesFilter,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ListPaneComponent);
